var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"journey-media-container"},[(_vm.media.type === 'video')?_c('BrightcoveVideo',{attrs:{"id":_vm.media.video.ref}}):(_vm.media.type === 'image')?_c('img',{attrs:{"role":"presentation","src":_vm.media.image.src}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }